import { Controller, useFormContext } from 'react-hook-form';
import type { CheckboxProps, SxProps, Theme } from '@mui/material';
import { Checkbox as MuiCheckbox, FormControlLabel } from '@mui/material';
import type { ChangeEvent, FC } from 'react';

interface CheckboxComponentProps extends Omit<CheckboxProps, 'name' | 'onChange'> {
  name: string;
  label?: string;
  onChange?: (checked: boolean) => void;
  controlLabelSx?: SxProps<Theme>;
  dataTestId?: string;
}

const Checkbox: FC<CheckboxComponentProps> = ({ name, label, onChange, controlLabelSx, dataTestId, ...restProps }) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <FormControlLabel
            control={
              <MuiCheckbox
                checked={!!field.value}
                onChange={(_event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
                  field.onChange(checked);
                  typeof onChange === 'function' && onChange(checked);
                }}
                inputProps={{ 'aria-label': label, 'data-testid': dataTestId }}
                {...restProps}
              />
            }
            label={label}
            sx={controlLabelSx}
          />
        );
      }}
    />
  );
};

export default Checkbox;
